<template>
  <div id="analysis-categs" class="mx-auto mt-5">
    <div id="brief">
      <div id="briefs">
        <IndexBrief
          v-for="idx in indexCompare"
          :key="idx.title"
          :location="location"
          :indexCompare="idx"
          :countyList="countyList"
          :townList="townList"
        />
      </div>
    </div>
    <div class="topics my-5 d-none d-sm-flex">
      <!--desktop-->
      <swiper class="swiper" ref="topicSwiper" :options="swiperOption">
        <swiper-slide
            v-for="topic in topics"
            :key="topic"
            class="topic px-2 mr-2"
            :class="{active: topicSelected == topic}"
          >
          <div class="btn btn-block text-center" @click="topicSelected = topic">{{ topic }}</div>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="topics my-5 d-sm-none">
      <!--mobile-->
      <div class="form-row">
        <select class="form-control col-12" @change="changeTopic($event)">
          <option v-for="topic in topics" :key="topic" :selected="topicSelected == topic">
            {{ topic }}
          </option>
        </select>
      </div>
    </div>
    <TopicContent
      v-if="topicSelected != null"
      :location="location"
      :categ = "categ"
      :subcateg="currentSubcateg"
    />
    </div>
</template>

<script>
import IndexBrief from "./index-brief.vue";
import TopicContent from "./topic-content.vue";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  components: { IndexBrief, TopicContent, Swiper, SwiperSlide },
  props: [
    "countyList",
    "townList",
    "location",
    "currentTab",
    "categ",
    "indexCompare",
  ],
  data() {
    return {
      topicSelected: this.categ.subcategs[0].title,
      loading: true,
      swiperOption: {
          slidesPerView: 1,
          spaceBetween: 10,
          grabCursor: true,
          watchOverflow: true,
          breakpoints: {
            1560: {
              slidesPerView: 6
            },
            1200: {
              slidesPerView: 5
            },
            992: {
              slidesPerView: 4
            },
            768: {
              slidesPerView: 3
            },
            576: {
              slidesPerView: 2
            },
            320: {
              slidesPerView: 1
            }
          },
          freeMode: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
    };
  },
  computed: {
    topics() {
      return this.categ.subcategs.map((x) => x.title);
    },
    currentSubcateg() {
      if (this.topicSelected == null) return null;
      return this.categ.subcategs.filter(
        (x) => x.title == this.topicSelected
      )[0];
    },
  },
  watch: {
    categ() {
      this.topicSelected = this.categ.subcategs[0].title;
      this.$refs.topicSwiper.$swiper.slideTo(0);
    },
  },
  methods: {
    changeTopic(e) {
      this.topicSelected = e.target.value;
      this.$refs.topicSwiper.$swiper.slideTo(e.target.selectedIndex);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/custom_var";
@import "../../css/custom_mixin";

#brief {
  margin-bottom: 30px;
  .bulb {
    width: 50px;
    height: 50px;
  }
}

.topics {
  .topic {
    min-width: 240px;
    height: 40px;
    border: $ts-orange 1px solid;
    color: $ts-orange;
    cursor: pointer;
    @include flex-center();
    @include transition(all 0.3s ease);

    &.active {
      color: white;
      background: $ts-orange;
    }
  }
}
</style>
